<div class="header-container">
  <div class="toggle" (click)="handleSidebarToggle()">
    <img src="./assets/images/btn-ham.png" alt="" height="32" width="32">
  </div>
    <!-- logo -->
    <div>
    </div>
    <!-- menu -->
     <div>
        <div class="btn-header">TH</div>
        <div class="btn-header" mat-button [matMenuTriggerFor]="profile"><img src="./assets/images/icon-profile.png" alt="bell" width="18" height="18"></div>
        <mat-menu #profile="matMenu">
            <button [routerLink]="'/profile'" mat-menu-item>จัดการบัญชีผู้ใช้</button>
            <button (click)="logout()" mat-menu-item>ออกจากระบบ</button>
          </mat-menu>
     </div>
</div>